module.exports = __webpack_public_path__ + "static/img/banner.26704d39.jpg";